import { type FC, useContext } from 'react'
import { useIntl } from 'react-intl'

import { FormControl, FormHelperText, FormLabel, Input } from 'base-ui'

import { LoginRegistrationRegistrationFormStateContext } from '../../context/LoginRegistrationRegistrationFormStateContext'

export const LoginRegistrationRegistrationFormEmailInput: FC = () => {
  const intl = useIntl()
  const { registrationFormState } = useContext(
    LoginRegistrationRegistrationFormStateContext,
  )
  const { model } = registrationFormState

  return (
    <FormControl
      error={!model.validator.isPropertyValid('email')}
      required
      value={model.email}
    >
      <FormLabel htmlFor="registerForm-eMail">
        {intl.formatMessage({ id: 'general.label.email' })}
      </FormLabel>
      <Input
        {...registrationFormState.makeInputProps('email', {
          validateOnBlur: true,
        })}
        id="registerForm-eMail"
        slotProps={{
          input: { 'data-qa-id': 'register-form-email' },
        }}
        type="email"
      />
      {model.validator.getFirstErrorFor('email') && (
        <FormHelperText>
          {model.validator.getFirstErrorFor('email')}
        </FormHelperText>
      )}
    </FormControl>
  )
}
